<ng-container *ngIf="content$ | async as content">
  <div
    *ngIf="itemsObs$ | async as items"
    [ngClass]="{ 'pr-small-t': !content.subjectTaxonomyTags.includes(TAXONOMY.NO_PADDING) }"
    class="mr-xlarge-b"
    [class.section-marker]="!content.subjectTaxonomyTags.includes(TAXONOMY.NO_SECTION_MARKER)"
  >
    <h2
      class="mr-clear-t"
      [ngClass]="{
        'align-center': content.subjectTaxonomyTags.includes(TAXONOMY.CENTERED),
      }"
      *ngIf="content.teaserTitle as title"
    >
      {{ title }}
    </h2>
    <div class="pr-medium-b" *ngIf="content.teaserText" [innerHTML]="content.teaserText | finSafe: 'html'"></div>

    <div class="discover-now-area">
      <div *ngFor="let item of items" class="discover-now-item pr-medium-r">
        <!-- FIXME: add icons once CMS return them -->
        <div class="discover-now-image">
          <fin-content-image
            *ngIf="item?.media?.length"
            class="block mr-medium-b"
            [imageData$]="item.media[0] | finToObservable"
          />
        </div>
        <h3 class="nordic-blue-900-text text-icon-primary">{{ item.teaserTitle }}</h3>
        <div [innerHTML]="item.teaserText | finSafe: 'html'" class="discover-now-teaser-text"></div>
        <div class="discover-now-links">
          <ng-container *ngFor="let related of item.related">
            <fcom-link
              *ngIf="isNewBrand()"
              class="block pr-xxsmall-t"
              [href]="related?.target?.url"
              [external]="related?.target?.external"
              [openInNewTab]="related?.target?.openInNewTab"
              [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
              >{{ related?.teaserTitle }}</fcom-link
            >
            <a
              *ngIf="!isNewBrand()"
              [finLink]="related?.target?.url"
              [external]="related?.target?.external"
              [attr.target]="related?.target?.openInNewTab ? '_blank' : null"
              class="flex flex--middle nordic-blue-900-text text-icon-primary bold-type no-underline pr-xxsmall-t font-body-1 underline-hover font-body-medium-bold"
            >
              <span class="title">{{ related?.teaserTitle }}</span>
              <span class="cta">
                <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
              </span>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
